import { Form, type FormListFieldData } from 'ui';
import type { ActivityOption, TaskKindOption } from '../../activity-types';
import { TaskInput } from './task-input';
import { TaskSwitch } from './task-switch';

type P = {
  disabledEdit: boolean;
  disabledEditWithings: boolean;
  field: FormListFieldData;
  onSelectTaskKind: (kind: TaskKindOption) => void;
  type: ActivityOption;
};

const Task = ({ disabledEdit, disabledEditWithings, field, onSelectTaskKind, type }: P) => {
  switch (type) {
    case 'extended-feedback':
      return (
        <TaskInput
          disabledEdit={disabledEdit}
          field={field}
          item={{ extra: 'What is expected? (e.g.: personal feedback to the webinar)', label: 'Activity name' }}
          placeholder="What is expected? (e.g.: personal feedback to the webinar)"
        />
      );
    case 'numeric-feedback':
      return (
        <TaskInput
          disabledEdit={disabledEdit}
          disabledEditWithings={disabledEditWithings}
          field={field}
          item={{ extra: 'What is expected? (e.g.: your blood sugar value)', label: 'Activity name' }}
          onSelectTaskKind={onSelectTaskKind}
          placeholder="What is expected? (e.g.: your blood sugar value)"
          withKindSelect
        />
      );
    case 'select-feedback':
    case 'withings-blood-pressure':
      return (
        // eslint-disable-next-line no-restricted-syntax -- TODO: fix later
        <Form.Item
          noStyle
          // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access -- TODO: disabled by automatic tool, need to check if it could be fixed or stay ignored in some rare cases
          shouldUpdate={(previousValues, currentValues) => previousValues.tasks !== currentValues.tasks}
        >
          {() => <TaskSwitch disabledEdit={disabledEdit} field={field} />}
        </Form.Item>
      );
  }
};

export default Task;
